export const IN_PROGRESS = 'In Progress';
export const COMPLETED = 'Completed';
export const SIGNING = 'Signing';
export const SIGNED = 'Signed';
